import React from 'react';
import PropTypes from 'prop-types';

import { FormField } from 'uikit/forms';
import FormFieldCondition from '../components/formFieldCondition';
import { getField } from '../forms';

const FormFieldContainer = ({
  model,
  type,
  form,
  schema,
  variant = 'default',
  value = null,
  label = '',
  help = '',
  className = '',
  fieldId = '',
  fieldKey = '',
  condition = {},
  error = '',
  hasCondition = false,
  hasError = false,
  onUpdateField = () => {},
  isRequired = false,
  isDirty = false,
  isFormDisabled = false,
  isFeature = false,
  featureCategory = 'default',
  featureIcon = null,
}) => {
  const FormFieldComponent = getField(type);

  if (!FormFieldComponent) {
    console.warn(
      `You're trying to render a form field (${type}) that has not been registered. Look at the schema for ${fieldKey}`,
    );
    return null;
  }

  const updateField = (update) => {
    const updateObject = {};
    updateObject[fieldKey] = update;
    return onUpdateField({
      update: updateObject,
    });
  };

  const updateFields = (updateObject) =>
    onUpdateField({
      update: updateObject,
    });

  return (
    <FormField
      className={className}
      error={error}
      featureCategory={featureCategory}
      featureIcon={featureIcon}
      fieldId={fieldId}
      hasError={hasError}
      help={help}
      isDirty={isDirty}
      isFeature={isFeature}
      isRequired={isRequired}
      label={label}
      schema={schema}
      type={type}
    >
      <FormFieldCondition hasCondition={hasCondition} condition={condition} />
      <FormFieldComponent
        variant={variant}
        model={model}
        schema={{ ...schema, isDisabled: schema.isDisabled || isFormDisabled }}
        value={value}
        fieldId={fieldId}
        fieldKey={fieldKey}
        form={form}
        updateField={updateField}
        updateFields={updateFields}
        hasError={hasError}
      />
    </FormField>
  );
};

FormFieldContainer.propTypes = {
  model: PropTypes.shape({}).isRequired,
  variant: PropTypes.string,
  type: PropTypes.string.isRequired,
  value: PropTypes.any,
  label: PropTypes.string,
  help: PropTypes.string,
  className: PropTypes.string,
  fieldId: PropTypes.string,
  fieldKey: PropTypes.string,
  form: PropTypes.shape({}).isRequired,
  schema: PropTypes.shape({
    isDisabled: PropTypes.bool,
    LabelAddOn: PropTypes.elementType,
    placeholder: PropTypes.string,
    shouldHideErrors: PropTypes.bool,
  }).isRequired,
  condition: PropTypes.shape({}),
  hasCondition: PropTypes.bool,
  error: PropTypes.string,
  hasError: PropTypes.bool,
  onUpdateField: PropTypes.func,
  isRequired: PropTypes.bool,
  isDirty: PropTypes.bool,
  isFormDisabled: PropTypes.bool,
  isFeature: PropTypes.bool,
  featureCategory: PropTypes.string,
  featureIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default React.memo(FormFieldContainer);
